import { useStaticRouteTitle } from "util/routeHelpers";
import * as React from "react";
import { createContext, useContext } from "react";

import { Helmet } from "react-helmet";
import { RequireAtLeastOne } from "type-fest";

interface BasePageTitleProps {
  title?: string;
  titleTemplate?: string | null;
  children: React.ReactNode;
}

type PageTitleProps = RequireAtLeastOne<
  BasePageTitleProps,
  "title" | "titleTemplate"
>;

export const PageTitleContext = createContext("");

export function PageTitle(props: PageTitleProps) {
  const parentTitleTemplate = useContext(PageTitleContext);

  const title = useStaticRouteTitle();

  const titleTemplate = props.titleTemplate
    ? `${props.titleTemplate} ${parentTitleTemplate}`
    : parentTitleTemplate;

  return (
    <PageTitleContext.Provider value={titleTemplate}>
      <Helmet titleTemplate={`%s ${titleTemplate}`}>
        <title>{title}</title>
      </Helmet>
      {props.children}
    </PageTitleContext.Provider>
  );
}
